import React from "react";
import { TreeSelect } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";

import * as actions from "../../actions";
import * as Template from "../../templates";

import EditorField from "../../templates/modules/forms/Editor";
import { useNavigate, useParams } from "react-router-dom";


const CreateProducts = () => {

  const moduleName = "products";

  const appReducer = useSelector((state) => state.appReducer, shallowEqual);
  const dispatch = useDispatch();
  const params = useParams()
  const navigate = useNavigate()
  const [id, setId] = useState();
  const [name, setName] = useState(``);
  const [slug, setSlug] = useState(``);
  const [code, setCode] = useState(``);
  const [content, setContent] = useState(``);
  const [type, setType] = useState(``);
  const [description, setDescription] = useState(``);
  const [categoryId, setCategoryId] = useState()
  const [attributeId, setAttributeId] = useState()
  const [brandId, setBrandId] = useState()
  const [brands, setBrands] = useState([]);
  const [images, setImages] = useState([])
  const [original, setOriginal] = useState()
  const [productCategories, setProductCategories] = useState()
  const [productAttributes, setProductAttributes] = useState([])
  const [productAttributePrices, setProductAttributePrices] = useState([]);
  const [submitted, setSubmitted] = useState(false);
  const [metaDescription, setMetaDescription] = useState(``);
  const [metaKeywords, setMetaKeywords] = useState(``);
  const [metaTitle, setMetaTitle] = useState(``);
  const [uploadSubmit, setUploadSubmit] = useState(false);
  const [attrValues, setAttrValues] = useState();
  const [attrValuesOrders, setAttrValuesOrders] = useState();

  const handleSelectBrand = value => setBrandId(value)

  const handleChangeType = value => setType(value)

  const handleChangeAttribute = value => setAttributeId(value)

  const handleDescriptionChange = content => setDescription(content)

  const handleDeleteImage = (id) => {
    setUploadSubmit(true)
    dispatch(actions.destroy(id, "images"))
  }

  const handleDefaultImage = (id) => {
    setUploadSubmit(true)
    dispatch(actions.edit(id, "images"))
  }

  useEffect(() => {
    if (submitted) {
      if (
        (appReducer.products_store != undefined && appReducer.products_store.error == false) ||
        (appReducer.products_update != undefined && appReducer.products_update.error == false)
      ) {
        navigate(-1)
      }
    }
    return () => setSubmitted(false)
  }, [appReducer])


  const handleImage = () => {
    setUploadSubmit(true)
    dispatch(actions.upload(id, "images"))
  }

  const hanleOnChange = (value) => setCategoryId(value)

  useEffect(() => {
    if (categoryId != undefined) {
      dispatch(actions.edit(categoryId, "product_categories/attributes"))
      dispatch(actions.edit(categoryId, "product_categories/price_attributes"))
    }
  }, [categoryId])

  const handleClick = () => {
    setSubmitted(true)
    if (id != undefined) {
      dispatch(actions.update(id, moduleName));
    } else {
      dispatch(actions.store(moduleName));
    }
  }

  useEffect(() => {
    if (appReducer.product_categories_price_attributes_edit != undefined && categoryId != undefined) {

      let productAttributePricesOption = []

      appReducer.product_categories_price_attributes_edit.data.map(item => {
        productAttributePricesOption.push({
          label: item.name,
          value: item.id,
        })
      })

      setProductAttributePrices(productAttributePricesOption)
    }
    if (appReducer.product_categories_attributes_edit != undefined && categoryId != undefined) {
      setProductAttributes(appReducer.product_categories_attributes_edit.data)
    }
    if (appReducer.product_categories_commissional_list != undefined) {
      setProductCategories(appReducer.product_categories_commissional_list.data)
    }
    if (appReducer.brands_option_list != undefined) {
      setBrands(appReducer.brands_option_list.data)
    }
    if (uploadSubmit) {
      if (appReducer.images_upload != undefined || appReducer.images_destroy != undefined) {
        if (id != undefined) {
          dispatch(actions.edit(id, moduleName))
          setUploadSubmit(false)
        }
      }
      if (appReducer.images_edit != undefined) {
        if (id != undefined) {
          dispatch(actions.edit(id, moduleName));
        }
      }
    }

    if (appReducer.products_edit != undefined && id != undefined) {
      let edit = appReducer.products_edit.data
      if (edit) {
        setName(edit.name)
        setSlug(edit.slug)
        setCode(edit.code)
        setContent(edit.content)
        setDescription(edit.description)
        setMetaTitle(edit.meta_title)
        setMetaDescription(edit.meta_description)
        setMetaKeywords(edit.meta_keywords)
        if (edit.attribute) {
          setAttributeId({
            value: edit.attribute.id,
            label: edit.attribute.name
          })
        }
        setBrandId({
          value: edit.brand_id,
          label: edit.brand.name,
        })


        let originalTitle = "اصل"

        switch (edit.original) {
          case "fake":
            originalTitle = "غیراصل"
            break;
          case "copy":
            originalTitle = "کپی"
            break;
          case "high_copy":
            originalTitle = "های‌کپی"
            break;
          case "is_fake":
            originalTitle = "فیک"
            break;
          case "tester":
            originalTitle = "تستر"
            break;
        }

        setOriginal({
          value: edit.original,
          label: originalTitle
        })

        setType({
          value: edit.type,
          label: edit.type == "consumable" ? "قابل‌فروش" : "به‌زودی",
        })

        setCategoryId(edit.category.name)

        setImages(edit.images)

        if (edit.attributes) {

          edit.attributes.map((attr) => {

            setAttrValuesOrders(prevState => ({ ...prevState, [`attribute_items_${attr.attribute_id}`]: attr.orders }));

            if (attr.attribute.option != 'simple') {

              if (attr.attribute.multiple == 'multiple') {

                let arrayValues = [];
                attr.value.map((data) => {
                  arrayValues.push({
                    value: data,
                    label: data
                  });
                });

                setAttrValues(prevState => ({ ...prevState, [`attribute_items_${attr.attribute_id}`]: arrayValues }));


              } else {

                setAttrValues(prevState => ({
                  ...prevState, [`attribute_items_${attr.attribute_id}`]: {
                    value: attr.value[0],
                    label: attr.value[0],
                  }
                }));

              }

            } else {

              setAttrValues(prevState => ({ ...prevState, [`attribute_items_${attr.attribute_id}`]: attr.value[0] }));

            }
          })
        }
      }


    }
  }, [appReducer])

  const handleChangeOrigin = (value) => setOriginal(value)

  useEffect(() => {
    dispatch(actions.list("product_categories/commissional"));
    dispatch(actions.list("brands/option"));
  }, [])


  useEffect(() => {
    if (id != undefined) {
      dispatch(actions.edit(id, moduleName));
    }
  }, [id]);

  useEffect(() => {
    if (params.id != undefined) {
      setId(params.id)
    }
  }, [params])


  return <div>
    {id && (
      <form className="mb-5" id="upload" method="post">
        <Template.FileInput clas name="image" label="تصویر" />
        <div className="flex my-3 items-center">
          <Template.Button
            label="آپلود"
            onClick={handleImage}
          />
        </div>
        {images && <div className="galleries">
          <ul className="my-5">
            {
              images.map((image, im) => {
                return <li className="flex w-full justify-between bg-neutral-100 p-4 border border-neutral-200  items-center" key={im} >
                  <img src={image.url_medium_full} />
                  <div className="flex items-center gap-3">
                    <Template.Button onClick={() => handleDeleteImage(image.id)} label="حذف" background="bg-gradient-to-tr from-red-300 to-red-400  text-xs" />
                    <Template.Button onClick={() => handleDefaultImage(image.id)} label="پیش فرض" />
                    {image.default == 1 ? <span>  <svg className=" flex-shrink-0 size-10" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M17 9L9.99998 16L6.99994 13M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="#8ce175" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path> </g></svg>
                    </span> : ""}
                  </div>
                </li>
              })
            }
          </ul>
        </div>}
      </form>
    )}
    <Template.Form>

      <div>
        <label>انتخاب سرگروه <i className="text star">*</i></label>
        <TreeSelect
          treeData={productCategories}
          showSearch
          style={{ width: "100%" }}
          value={categoryId}
          dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
          placeholder="انتخاب گروه"
          allowClear
          treeDefaultExpandAll
          onChange={hanleOnChange}
        />
        <input
          defaultValue={categoryId}
          type="hidden"
          name="product_category_id"
        />
      </div>


      {productAttributes.length ? <div className="bg-neutral-100 border border-neutral-200 px-5 py-8">
        {productAttributes.map((cat, c) => {
          return (
            <div key={c} className="flex flex-col space-y-5">
              <span className="font-bold text-lg">{cat.name}</span>

              <div className=" grid grid-cols-4 gap-8">
                {cat.attributes.map(function (attribute, a) {

                  let attribute_item_options = [];

                  if (attribute.attribute_items.length > 0) {
                    attribute.attribute_items.map((item, i) => {
                      return attribute_item_options.push({
                        label: item.name,
                        value: item.name,
                      });
                    });
                  }

                  return (
                    <div key={a}>
                      {attribute.attribute_items.length == 0 ? (
                        <div>
                          <Template.Input
                            required={attribute.required == 'required' ? true : false}
                            name={`attribute_items[${attribute.id}]`}
                            value={attrValues ? attrValues[`attribute_items_${attribute.id}`] : ""}
                            label={attribute.name}
                          />
                          <Template.Input value={attrValuesOrders ? attrValuesOrders[`attribute_items_${attribute.id}`] : ""} name={`orders[${attribute.id}]`} placeholder="ترتیب"  />
                        </div>
                      ) : (
                        <div>
                          <Template.SingleSelect
                            multi={attribute.multiple == 'multiple' ? true : false}
                            required={attribute.required == 'required' ? true : false}
                            withLabel
                            placeholder={attribute.name}
                            value={attrValues ? attrValues[`attribute_items_${attribute.id}`] : ""}
                            onChange={value => {
                              setAttrValues(prevState => ({ ...prevState, [`attribute_items_${attribute.id}`]: value }));
                            }}
                            name={attribute.multiple == 'multiple' ? `attribute_items[${attribute.id}][]` : `attribute_items[${attribute.id}]`}
                            options={attribute_item_options}
                          />
                          <Template.Input value={attrValuesOrders ? attrValuesOrders[`attribute_items_${attribute.id}`] : ""} name={`orders[${attribute.id}]`} placeholder="ترتیب"  />

                        </div>
                      )}
                    </div>
                  );
                }
                )}
              </div>
            </div>
          )
        })}
      </div> : ""}

      <Template.SingleSelect
        withLabel
        required
        placeholder="تنوع قیمت بر اساس"
        onChange={handleChangeAttribute}
        name="attribute_id"
        value={attributeId}
        options={productAttributePrices}
      />

      <Template.SingleSelect
        withLabel
        required
        placeholder="اصالت کالا"
        onChange={handleChangeOrigin}
        name="original"
        value={original}
        options={[
          {
            value: "original",
            label: "اصل",
          },
          {
            value: "fake",
            label: "غیراصل",
          },
          {
            value: "copy",
            label: "کپی",
          },
          {
            value: "high_copy",
            label: "های‌کپی",
          },
          {
            value: "is_fake",
            label: "فیک",
          },
          {
            value: "tester",
            label: "تستر",
          },
        ]}
      />

      <Template.Input
        required
        value={name}
        label="عنوان فارسی"
        name="name"
        type="text"
      />

      <Template.Input
        required
        value={slug}
        label="عنوان انگلیسی"
        name="slug"
        type="text"
      />

      <Template.Input
        required
        value={code}
        label="کد محصول"
        className="ltr"
        name="code"
        type="text"
      />

      <Template.Textarea
        required
        value={content}
        label="شرح کالا"
        name="content"
        type="text"
      />


      <Template.SingleSelect
        withLabel
        required
        placeholder="انتخاب برند"
        name="brand_id"
        options={brands}
        value={brandId}
        onChange={handleSelectBrand}
      />

      <Template.SingleSelect
        withLabel
        required
        placeholder="نوع"
        onChange={handleChangeType}
        name="type"
        value={type}
        options={[
          {
            value: "consumable",
            label: "قابل‌فروش",
          },
          {
            value: "soon",
            label: "به‌زودی",
          },
        ]}
      />

      <div>
        <EditorField
          label="توضیحات تکمیلی"
          onEditorChange={handleDescriptionChange}
          value={description}
        />
        <input name="description" type="hidden" defaultValue={description} />
      </div>

      <Template.Seo
        keywords={metaKeywords}
        description={metaDescription}
        title={metaTitle}
      />

      <Template.Button
        label="ذخیره"
        onClick={handleClick}
      />

    </Template.Form>
  </div>
}


export default CreateProducts
